

import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function Booking({



 cards = [
  {
    title: "Maruti Swift Dzire",
    company: "SRS Cab Service",
    seater: "4+1",
    priceLabel: "On Call",
    desc: "Maruti Swift Dzire is a reliable sedan with smooth handling and spacious interiors—ideal for everyday travel, airport transfers, and short trips.",
    image: "/images/fleet/Maruti-swift-Dzire.jpg",
  },
  {
    title: "Honda Amaze",
    company: "SRS Cab Service",
    seater: "4+1",
    priceLabel: "On Call",
    desc: "Honda Amaze is a compact sedan with comfortable interiors and excellent mileage—perfect for city commutes, airport drops, and small family travel.",
    image: "/images/fleet/Honda-Amaze.jpg",
  },
  {
    title: "Toyota Etios",
    company: "SRS Cab Service",
    seater: "4+1",
    priceLabel: "On Call",
    desc: "Toyota Etios is a practical sedan known for its comfort and fuel efficiency—perfect for daily travel, airport transfers, and short city rides.",
    image: "/images/fleet/Toyota-Etios.jpg",
  },
  {
    title: "Toyota Corolla Altis",
    company: "SRS Cab Service",
    seater: "4+1",
    priceLabel: "On Call",
    desc: "Toyota Corolla Altis is a premium sedan offering superior comfort, smooth driving, and elegant interiors—ideal for business travel, city rides, and executive trips.",
    image: "/images/fleet/Toyota-corolla-Altis.jpg",
  },
  {
    title: "Maruti Ertiga",
    company: "SRS Cab Service",
    seater: "6+1",
    priceLabel: "On Call",
    desc: "Maruti Ertiga is a versatile MPV offering comfortable seating and great fuel efficiency—perfect for family outings, group travel, and city tours.",
    image: "/images/fleet/Maruti-Ertiga.jpg",
  },
  {
    title: "Mahindra Scorpio",
    company: "SRS Cab Service",
    seater: "6+1",
    priceLabel: "On Call",
    desc: "Mahindra Scorpio is a powerful SUV designed for comfortable long-distance travel and rough terrains—ideal for outstation trips, group travel, and adventure journeys.",
    image: "/images/fleet/Scorpio.jpg",
  },
  {
    title: "Toyota Innova",
    company: "SRS Cab Service",
    seater: "7+1",
    priceLabel: "On Call",
    desc: "Toyota Innova is a trusted MPV offering spacious seating, strong AC, and a smooth ride—ideal for family tours, corporate travel, and outstation trips.",
    image: "/images/fleet/Toyota-Innova.jpg",
  },
  {
    title: "Toyota Innova Crysta",
    company: "SRS Cab Service",
    seater: "7+1",
    priceLabel: "On Call",
    desc: "Toyota Innova Crysta combines luxury, space, and performance—ideal for premium travel, corporate trips, and long-distance family journeys.",
    image: "/images/fleet/Innova-Crysta.jpg",
  },
  {
    title: "Chevrolet Tavera",
    company: "SRS Cab Service",
    seater: "8+1",
    priceLabel: "On Call",
    desc: "Chevrolet Tavera offers spacious seating and reliable performance, making it perfect for family trips, group travel, and long-distance journeys with comfort.",
    image: "/images/fleet/Tavera.jpg",
  },
  {
    title: "Mini Bus",
    company: "SRS Cab Service",
    seater: "12-20",
    priceLabel: "On Call",
    desc: "Mini Bus is perfect for large group travel, offering ample seating and comfort—ideal for tours, events, corporate outings, and long-distance group trips.",
    image: "/images/fleet/mini-bus.jpg",
  },
],
// ],
}) {
  const handleWhatsAppBooking = (title) => {
    const phone = "919011955415";
    const message = `Hello Srs Cab Service, I want to book ${title}. Please share details.`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* Breadcrumb */}
 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Online Booking</h2>
           
          </div>
        </div>
      </div>
    </div>

    

      {/* Cards */}
      <section
        className="taxi-rates-page section-space"
        style={{ backgroundColor: "#f9fafc", padding: "80px 0" }}
      >
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((c, idx) => (
              <div className="col-xl-4 col-md-6 d-flex" key={idx}>
                <div
                  className="taxi-card d-flex flex-column"
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    overflow: "hidden",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                    height: "100%",
                  }}
                >
                  {/* Image */}
                  <div style={{ backgroundColor: "#CE8304", padding: "20px" }}>
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      style={{
                        width: "100%",
                        maxHeight: "220px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      backgroundColor: "#606060",
                      color: "#fff",
                      padding: "25px 20px",
                      flex: "1",
                    }}
                    className="d-flex flex-column justify-content-between"
                  >
                    <div>
                      <h3 className="text-center mb-2">{c.title}</h3>
                      <p
                        className="text-center mb-3"
                        style={{ color: "#cfcfcf", fontSize: "0.9rem" }}
                      >
                        {c.company}
                      </p>

                      <p className="text-center mb-3">{c.desc}</p>

                      <p className="text-center fw-bold">
                        Seater: {c.seater}
                      </p>
                    </div>

                    <div className="text-center mt-3">
                      <button
                        onClick={() => handleWhatsAppBooking(c.title)}
                        className="btn d-inline-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "#CE8304",
                          color: "#fff",
                          padding: "10px 22px",
                          borderRadius: "6px",
                          border: "none",
                          fontWeight: 600,
                          width: "65%",
                        }}
                      >
                        <i className="fab fa-whatsapp me-2" /> Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

